import { useEffect, useState } from "preact/hooks"
import { useFormContext } from "../../context/form-context"
import { HintButton } from "./hint"
import { hasIcons, Icon } from "./icon.js"

const gettext = window.gettext

export const Checkboxes = (props) => {
  const { inFormValues, step: stepId, setModalData } = useFormContext()

  const classList = () => {
    const classes = ["checkboxes"]
    props.max_selections === 1 || classes.push("multiple")
    props.class && classes.push(props.class)
    return classes.join(" ")
  }

  const reporterType = inFormValues({
    name: "reporter_type",
  })

  return (
    <fieldset class={classList()}>
      {props.label && <legend class="show-for-sr">{props.label}</legend>}
      {props.fields.map((f) => {
        const hint = props.hints?.[f[0]]
        const display = f[2] ? f[2] === reporterType?.value : true

        return display
          ? <Checkbox
              key={`${stepId}-${props.name}-${f[0]}`}
              field={f}
              singular={props.singular}
              max_selections={props.max_selections}
              function={props.function}
              name={props.name}
              icons={props.icons ?? false}
              wordmark={props.class === "wordmarks"}
            >
              {hint && (
                <HintButton
                  title={hint.title}
                  onClick={() => {
                    setModalData(hint)
                  }}
                />
              )}
            </Checkbox>
          : null
      })}
    </fieldset>
  )
}

export const Checkbox = (props) => {
  const {
    inFormValues,
    storedValues,
    toggleValue,
    requirementsMet,
    showStep,
    step: stepId,
  } = useFormContext()
  const [value, initialLabel] = props.field
  const { name } = props

  const [disabled, setDisabled] = useState(false)

  useEffect(() => {
    if (value === "mixed") {
      setDisabled(inFormValues({ name: "perpetrator_count", value: "single" }))
    }
  })

  const checkSingularCondition = (condition) => {
    if (condition === "perpetrator_count") {
      return singlePerpetrator()
    }
    return false
  }

  const isRequired = () => {
    return !requirementsMet(name)
  }

  const singlePerpetrator = () => {
    // let isSinglePerpetrator = typeof inFormValues({
    //   name: "perpetrator_count",
    //   value: "single",
    // }) === 'object'
    return (
      typeof inFormValues({
        name: "perpetrator_count",
        value: "single",
      }) === "object"
    )
  }

  const getDeleteSimilar = () => {
    const max = props.max_selections
    if (max === 1) return true
    if (max > 1) return max
    return checkSingularCondition(props.singular)
  }

  const deleteSimilar = getDeleteSimilar()

  const isAtMax =
    props.max_selections > 1 &&
    !inFormValues({ name, value }) &&
    storedValues.filter((o) => o.name === name).length >= props.max_selections

  const onChange = () => {
    setDisabled(true)
    toggleValue(
      {
        step: stepId,
        name,
        label,
        value,
      },
      deleteSimilar,
      props.function === "switch"
        ? ["perpetrator_role", "perpetrator_age", "perpetrator_gender"]
        : false,
    )

    props.function === "onClickNext" && showStep(1)

    setDisabled(false)
  }

  const label =
    props.conditional_label &&
    (value === "other" || value === "other_unknown") &&
    singlePerpetrator()
      ? props.conditional_label
      : initialLabel

  return (
    <div class="checkbox" key={`${name}-${value}`}>
      <input
        id={`${name}-${value}`}
        type="checkbox"
        value={value}
        name={name}
        disabled={disabled || isAtMax}
        checked={inFormValues({ name, value }) || false}
        onChange={onChange}
      />
      <label
        for={`${name}-${value}`}
        class={
          hasIcons
            ? `w-icon ${value} ${isRequired() && "required"}`
            : `${isRequired() && "required"}`
        }
      >
        {label}
        {hasIcons(name) ? <Icon name={value} /> : null}
        {props.wordmark
          ? <div class="button special-label">{gettext("melden")}</div>
          : null}
      </label>
      {props.children}
    </div>
  )
}
